import { Controller } from "@hotwired/stimulus";
import { fillInput } from "../utils/inputs_utils";

/**
 * Change the value of an input field based on clicks on elements
 */

export default class extends Controller {
  static targets = ["input"];

  update(e) {
    const value = e.currentTarget.dataset.chosenValue;
    fillInput(this.inputTarget, value);
  }

  replicate(e) {
    const value = e.currentTarget.value;
    fillInput(this.inputTarget, value);
  }
}
